import { useEffect } from 'react'
import { App } from 'antd'
import { WEB_UPDATE_EVENT } from '@/const/web-update.ts'

export function WebUpdateNotice() {
  const { modal } = App.useApp()

  useEffect(() => {
    const shownVersions = new Set<string>()
    let dialog: ReturnType<typeof modal.confirm> | undefined
    const onUpdate = (event: Event) => {
      if (!(event instanceof CustomEvent)) {
        return
      }
      const detail: unknown = event.detail
      if (!detail || typeof detail !== 'object' || !('version' in detail)) {
        return
      }
      const version = detail.version
      if (typeof version !== 'string' || !version || shownVersions.has(version) || dialog) {
        return
      }
      shownVersions.add(version)
      dialog = modal.confirm({
        title: '发现新版本',
        content: '系统已更新，刷新后即可使用最新版本。请先保存当前未提交的内容。',
        okText: '立即刷新',
        cancelText: '稍后再说',
        mask: { closable: false },
        onOk: () => location.reload(),
        afterClose: () => {
          dialog = undefined
        }
      })
    }
    document.body.addEventListener(WEB_UPDATE_EVENT, onUpdate)
    window.pluginWebUpdateNotice_?.checkUpdate()
    return () => {
      document.body.removeEventListener(WEB_UPDATE_EVENT, onUpdate)
      dialog?.destroy()
    }
  }, [modal])

  return null
}
